import React, { useEffect, useState } from "react";
import { ResponsivePie } from '@nivo/pie'
import ICON from "components/cmp_icon/cmp_icon";

import './cmp_statsummary.css';
import {Button} from "semantic-ui-react";



export default function CMP_STATSUMMARY({ var_data, var_refresh }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const [var_chartData, set_chartData] = useState([]);



    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {

        set_chartData([
            {
                "id": "Complete",
                "label": "Complete",
                "value": var_data.published_complete
            },
            {
                "id": "Incomplete",
                "label": "Incomplete",
                "value": var_data.published_incomplete
            },
            {
                "id": "Unpublished",
                "label": "Unpublished",
                "value": var_data.unpublished
            }
        ])

    }, [var_data])



    //  async functions ------------------------------------------------------------------------------------------------



    //  API calls ------------------------------------------------------------------------------------------------------



    //  event functions ------------------------------------------------------------------------------------------------

    function onClick_refresh(){
        var_refresh()
    }


    // RENDER CONTAINER ================================================================================================

    return (

        <div className='card stat summary providers'>

            <ResponsivePie
                data={var_chartData}
                colors={["#99c24c", "#fcb716", "#d93936"]}
                margin={{top: 8, right: 8, bottom: 8, left: 8}}
                innerRadius={0.85}
                padAngle={1}
                cornerRadius={5}
                activeOuterRadiusOffset={5}
                borderWidth={0}
                borderColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            0.2
                        ]
                    ]
                }}
                enableArcLinkLabels={false}
                enableArcLabels={false}
            />

            <Button className='button--refresh' onClick={onClick_refresh}>
                <ICON name='refresh' className='icon__refresh'  alt='refresh icon'/>
            </Button>
        </div>

    )
}